import {
  Dialog, DialogFooter, DialogType, mergeStyleSets, PrimaryButton, Text,
} from '@fluentui/react';
import React from 'react';
import Store from '../../shared/state/Store';
import UiReducer from '../../shared/state/UiReducer';
import ModellerDefaults from '../ModellerDefaults';
import ModellerReducer from '../ModellerReducer';
import ModelUtils from '../ModelUtils';
import Table from '../../shared/npt/Table';
import TableData from '../../shared/npt/TableData';

const componentStyles = mergeStyleSets({
  tableWrapper: {
    maxHeight: '70vh',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
  },
});

export default () => {
  const [globalState, dispatch] = Store.useStore();

  const dialogData = UiReducer.getGenericUiAttribute(globalState, ModellerDefaults.ComponentKeys.ModellerNodeProbabilityTableViewKey);

  const hide = () => {
    dispatch(UiReducer.setGenericUiAttribute(ModellerDefaults.ComponentKeys.ModellerNodeProbabilityTableViewKey, undefined));
  };

  if (!dialogData) {
    return <></>;
  }

  const {
    networkId, nodeId, networkName, nodeName,
  } = dialogData;
  const model = ModellerReducer.getModel(globalState);
  const network = ModelUtils.getNetwork({ model, networkId });
  const node = ModelUtils.getNode({ network, nodeId });

  // Build table data if network and node exist and node has a table
  let tableData = null;
  if (network && node && node.configuration?.table) {
    try {
      const tableType = node.configuration.table.type;
      // For Expression or Partitioned types, use buildExpressions
      if (tableType === 'Expression' || tableType === 'Partitioned') {
        tableData = TableData.buildExpressions(network, node);
      } else if (node.configuration.table.probabilities) {
        // For other types (e.g., Manual), use regular build
        tableData = TableData.build(network, node);
      }
    } catch (error) {
      console.error('Failed to build table:', error);
    }
  }

  return (
    <div style={{
      position: 'fixed',
      left: '-9999px',
      width: '0px',
      height: '0px',
    }}
    >
      <Dialog
        hidden={false}
        onDismiss={hide}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Probability Table',
        }}
        modalProps={{
          isBlocking: false,
        }}
        styles={{
          main: {
            maxWidth: '90vw !important',
          },
        }}
      >
        <Text block style={{ marginBottom: '10px' }}>
          {`Node: ${nodeName || 'N/A'}`}
        </Text>
        <Text block style={{ marginBottom: '10px' }}>
          {`Network: ${networkName || 'N/A'}`}
        </Text>

        {!tableData ? (
          <Text block style={{ padding: '10px', color: '#605e5c' }}>No probability table available</Text>
        ) : (
          <div className={componentStyles.tableWrapper}>
            <Table
              data={tableData}
              updateTable={() => {}} // No-op for read-only view
              editableHeaders={false}
              editableValues={false}
              optionsEnabled
              selectionEnabled={false}
              rangeSelectionEnabled={false}
            />
          </div>
        )}
        <DialogFooter>
          <PrimaryButton onClick={hide} text="Close" />
        </DialogFooter>
      </Dialog>
    </div>
  );
};
